<template>
	<el-input
		ref="input"
		type="hidden"
		class="input-llood-hidden"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
	/>
</template>

<script>
	export default {
		name: 'InputLloodHidden',
		props: {
			value: {
				default: ''
			},
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			overrideData () { return { hideInput: true } }

		}
	}
</script>
